var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero__inner"},[_c('h1',[_vm._t("title")],2),_c('p',[_vm._t("description")],2)]),_c('logo',{attrs:{"size":"sm","color":'white'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }